import { Modal, TextField } from "@shopify/polaris";
import React, { useCallback, useEffect, useReducer } from "react";
import { handleError, reducerFn } from "../../../helper";
import { useMutation } from "@apollo/react-hooks";
import { UPDATE_STORE_CURRENCY } from "../../../graphql/mutations";

export default function UpdateCurrency({
    open,
    onClose,
    store,
    refetch,
    setNotify,
    toggleActiveToast,
}) {
    const { id, currency } = store || {};

    const [state, setState] = useReducer(reducerFn, {
        currency: currency,
    });

    const timeoutRef = React.useRef(null);
    const [updateStore, { loading }] = useMutation(UPDATE_STORE_CURRENCY, {
        onCompleted: () => {
            setNotify({ msg: "Update Store currency success", err: false });
            onClose && onClose();
            if (refetch) {
                timeoutRef.current && clearTimeout(timeoutRef.current);
                timeoutRef.current = setTimeout(() => {
                    refetch();
                }, 1500);
            }
        },
        onError: (err) => {
            setNotify({ msg: handleError(err?.toString()), err: true });
        },
    });

    useEffect(() => {
        setState({ currency });
    }, [currency]);

    const handleSubmit = useCallback(() => {
        if (!id) return;

        toggleActiveToast(true);
        setNotify({ msg: null, err: false })
        updateStore({
            variables: {
                ids: [id],
                currency: state.currency,
            },
        });
    }, [updateStore, id, state.currency, toggleActiveToast, setNotify]);

    return (
        <Modal
            title="Update Store Currency"
            open={open}
            onClose={onClose}
            sectioned
            large
            primaryAction={{
                content: "Submit",
                onAction: handleSubmit,
                loading: loading,
            }}
            secondaryActions={[{ content: "Cancel", onAction: onClose }]}
        >
            <TextField
                label="Currency"
                value={state.currency}
                onChange={(value) => setState({ currency: value })}
                placeholder='Enter currency'
            />
        </Modal>
    );
}
